"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.appNotificationsRegisteredCallbacksKey = exports.appNotificationsKey = void 0;
/*
 * Normally you would use the Symbol constructor for injection keys.
 * We are intentionally using strings in order to be able to inject values
 * even if each federated module has its own copy of the commercial-web-client-utilities package.
 */
exports.appNotificationsKey = ('App Notifications Injection Key');
exports.appNotificationsRegisteredCallbacksKey = ('App Notifications Registered Callbacks Injection Key');
//# sourceMappingURL=injection-symbols.js.map